/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { getInstrumentConstantsEndPoint } from '../common/constants';
import { sendRequestAndReceiveResponse, filterNames, filterModels } from '../common/common';


const UPDATE_INSTRUMENTCONSTANTS_SELECTED_FAMILY = 'UPDATE_INSTRUMENTCONSTANTS_SELECTED_FAMILY';
const UPDATE_INSTRUMENTCONSTANTS_SELECTED_PRODUCTNAME = 'UPDATE_INSTRUMENTCONSTANTS_SELECTED_PRODUCTNAME';
const UPDATE_INSTRUMENTCONSTANTS_SELECTED_PRODUCTMODEL = 'UPDATE_INSTRUMENTCONSTANTS_SELECTED_PRODUCTMODEL';

const UPDATE_INSTRUMENTCONSTANTS_FILE_NAME = 'UPDATE_INSTRUMENTCONSTANTS_FILE_NAME';
const UPDATE_INSTRUMENTCONSTANTS_MODELNAME = 'UPDATE_INSTRUMENTCONSTANTS_MODELNAME';
const UPDATE_INSTRUMENTCONSTANTS_PART_NUMBER = 'UPDATE_INSTRUMENTCONSTANTS_PART_NUMBER';
const UPDATE_INSTRUMENTCONSTANTS_EXPORTDATA = 'UPDATE_INSTRUMENTCONSTANTS_EXPORTDATA';
const LOAD_INSTRUMENT_CONSTANTS = 'LOAD_INSTRUMENT_CONSTANTS';
const INSTRUMENTS_CONSTANTS_DATA = 'INSTRUMENTS_CONSTANTS_DATA';
const INSTRUMENTS_CONSTANTS_DATA_FOR_FILENAME = 'INSTRUMENTS_CONSTANTS_DATA_FOR_FILENAME';
const STOP_LOADING = 'STOP_LOADING';
const CLEAR_VIEW_CONSTANTS_STORE = ' CLEAR_VIEW_CONSTANTS_STORE';
const UPDATE_INSTRUMENTCONSTANTS_PRODUCTNAMES = 'UPDATE_INSTRUMENTCONSTANTS_PRODUCTNAMES';
const UPDATE_INSTRUMENTCONSTANTS_PRODUCTMODELS = 'UPDATE_INSTRUMENTCONSTANTS_PRODUCTMODELS';
const UPDATE_INSTRUMENTCONSTANTS_ALL_CLASSIFICATION = 'UPDATE_INSTRUMENTCONSTANTS_ALL_CLASSIFICATION';
const UPDATE_INSTRUMENTCONSTANTS_FAMILIES = 'UPDATE_INSTRUMENTCONSTANTS_FAMILIES';
const CLEAR_INSTRUMENTCONSTANTS_LIST = 'CLEAR_INSTRUMENTCONSTANTS_LIST';
const CLEAR_INSTRUMENTCONSTANTS_EXPORT_LIST = 'CLEAR_INSTRUMENTCONSTANTS_EXPORT_LIST';
const UPDATE_SEARCH_STATUS = 'UPDATE_SEARCH_STATUS';
const initialState = {
    data: {},
    families: [],
    productNames: [],
    productModels: [],
    fileName: '',
    partNumber: '',
    id: '',
}

export const actionCreators = {
    UpdateSelectedFamily: (selectedFamilies: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_INSTRUMENTCONSTANTS_SELECTED_FAMILY, selectedFamilies });
    },
    UpdateSelectedProductName: (SelectedProductNames: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_INSTRUMENTCONSTANTS_SELECTED_PRODUCTNAME, SelectedProductNames });
    },
    UpdateSelectedProductModel: (SelectedProductModels: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_INSTRUMENTCONSTANTS_SELECTED_PRODUCTMODEL, SelectedProductModels });
        const instrumentConstantsData = await sendRequestAndReceiveResponse(
            JSON.stringify({
                ClassificationId: SelectedProductModels[0],
                ClassificationType: 'productmodel',
            }),
            getInstrumentConstantsEndPoint
        );
        dispatch({ type: INSTRUMENTS_CONSTANTS_DATA, instrumentConstantsData });
    },
    UpdateFileName:
        (fileName: any) => async (dispatch: any, getState: any) => {
            dispatch({ type: UPDATE_INSTRUMENTCONSTANTS_FILE_NAME, fileName });
        },
    UpdatePartNumber: (partNumber: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_INSTRUMENTCONSTANTS_PART_NUMBER, partNumber });
    },
    Updatesearchstatus: (isSearchstarted: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SEARCH_STATUS, isSearchstarted });
    },
    UpdatepartNumbersearchresults: (instrumentConstantsData: any, IsPartConstant: boolean) => async (dispatch: any, getState: any) => {
        dispatch({ type: INSTRUMENTS_CONSTANTS_DATA, instrumentConstantsData, IsPartConstant});
    },
    UpdatefileNamesearchresults: (instrumentConstantsData: any, IsPartConstant: boolean) => async (dispatch: any, getState: any) => {
        dispatch({ type: INSTRUMENTS_CONSTANTS_DATA_FOR_FILENAME, instrumentConstantsData });
    },
    UpdateModelName:
        (ProductNames: any, id: any) => async (dispatch: any, getState: any) => {
            const final = ProductNames.find((element: { id: number }) => element.id == id);
            const modelname = final.name;
            dispatch({ type: UPDATE_INSTRUMENTCONSTANTS_MODELNAME, modelname });
        },
    LoadInstrumentConstants:
        (fileName: any) => async (dispatch: any, getState: any) => {
            dispatch({ type: LOAD_INSTRUMENT_CONSTANTS, fileName });
        },
    StopLoading: () => async (dispatch: any, getState: any) => {
        dispatch({ type: STOP_LOADING });
    },
    FilterNames:
        (Productfamilies: any, selectedProductFamily: any) =>
            async (dispatch: any, getState: any) => {
                let productNames: any = [];              
                productNames = filterNames(Productfamilies, selectedProductFamily);
                dispatch({ type: UPDATE_INSTRUMENTCONSTANTS_PRODUCTNAMES, productNames });
            },
    FilterModels:
        (ProductNames: any, selectedProductName: any) =>
            async (dispatch: any, getState: any) => {
                let productModels: any = [];
                productModels = filterModels(ProductNames, selectedProductName);
                dispatch({ type: UPDATE_INSTRUMENTCONSTANTS_PRODUCTMODELS, productModels });
            },

    UpdateProductFamilies:
        (families: any) => async (dispatch: any, getState: any) => {
            dispatch({ type: UPDATE_INSTRUMENTCONSTANTS_FAMILIES, families });
        },
    UpdateExportResults:
        (instrumentConstantsData: any) => async (dispatch: any, getState: any) => {
            dispatch({ type: UPDATE_INSTRUMENTCONSTANTS_EXPORTDATA, instrumentConstantsData });
        },
    ClearInstrumentConstantsList: () => async (dispatch: any, getState: any) => {
        dispatch({ type: CLEAR_INSTRUMENTCONSTANTS_LIST });
    },
    ClearInstrumentConstantsExportList: () => async (dispatch: any, getState: any) => {
        dispatch({ type: CLEAR_INSTRUMENTCONSTANTS_EXPORT_LIST });
    },
    ClearViewConstantsData: () => async (dispatch: any, getState: any) => {
        dispatch({ type: CLEAR_VIEW_CONSTANTS_STORE });
    },
   
}
export const reducer = (state: any, action: any) => {
    state = state || initialState;

    switch (action.type) {
        case UPDATE_INSTRUMENTCONSTANTS_SELECTED_FAMILY:
            return {
                ...state,
                selectedFamily: action.selectedFamilies,
                IsPartConstant: false,
                selectedProductName: undefined,
                selectedProductModel: undefined,
                instrumentConstantsData: undefined,
                isInstrumentConstantsLoading: false,
                isSearchstarted: false,
                fileName: '',
            };

        case UPDATE_INSTRUMENTCONSTANTS_PRODUCTNAMES:
            return {
                ...state,
                productNames: action.productNames,
                isInstrumentConstantsLoading: false,
            };
        case UPDATE_INSTRUMENTCONSTANTS_PRODUCTMODELS:
            return {
                ...state,
                productModels: action.productModels,
                isInstrumentConstantsLoading: false,
            };
        case UPDATE_INSTRUMENTCONSTANTS_SELECTED_PRODUCTNAME:
            return {
                ...state,
                selectedProductName: action.SelectedProductNames,
                instrumentConstantsData: undefined,
                selectedProductModel: undefined,
                isInstrumentConstantsLoading: true,
                fileName:'',
            };
        case UPDATE_INSTRUMENTCONSTANTS_SELECTED_PRODUCTMODEL:
            return {
                ...state,
                selectedProductModel: action.SelectedProductModels,
                isInstrumentConstantsLoading: true,
                isSearchstarted: true,
                fileName:''
                };

        case UPDATE_INSTRUMENTCONSTANTS_FILE_NAME:
            return {
                ...state,
                fileName: action.fileName,
                isSearchstarted: false
            };
        case UPDATE_INSTRUMENTCONSTANTS_PART_NUMBER:
            return {
                ...state,
                partNumber: action.partNumber,
                IsPartConstant: true,
                selectedFamily: undefined,
                selectedProductName: undefined,
                selectedProductModel: undefined,
            };
        case LOAD_INSTRUMENT_CONSTANTS:
            return {
                ...state,
                isInstrumentConstantsLoading: true,
                fileName: action.fileName,
                isSearchstarted: true,
                selectedFamily: undefined,
                selectedProductName: undefined,
                selectedProductModel: undefined,
            };
        case INSTRUMENTS_CONSTANTS_DATA:
            return {
                ...state,
                isInstrumentConstantsLoading: false,
                IsPartConstant: action.IsPartConstant,
                isSearchstarted: false,
                instrumentConstantsData: action.instrumentConstantsData,
            };
            case INSTRUMENTS_CONSTANTS_DATA_FOR_FILENAME:
            return {
                ...state,
                isInstrumentConstantsLoading: false,
                instrumentConstantsData: action.instrumentConstantsData,
            };
        case STOP_LOADING:
            return {
                ...state,
                isInstrumentConstantsLoading: false,
            };
        case UPDATE_INSTRUMENTCONSTANTS_ALL_CLASSIFICATION:
            return {
                ...state,
                selectedFamily: action.selectedFamily,
                selectedProductName: action.selectedProductName,
                selectedProductModel: action.selectedProductModel,
                instrumentConstantsData: action.instrumentConstantsData,
                isInstrumentConstantsLoading: false,
            };
        case UPDATE_INSTRUMENTCONSTANTS_FAMILIES:
            return {
                ...state,
                families: action.families,
            };
        case UPDATE_INSTRUMENTCONSTANTS_MODELNAME:
            return {
                ...state,
                modelname: action.modelname,
            };
        case UPDATE_INSTRUMENTCONSTANTS_EXPORTDATA:
            return {
                ...state,
                instrumentConstantsData: undefined,               
            };
        case CLEAR_VIEW_CONSTANTS_STORE: {
            return initialState;
        }
        case UPDATE_SEARCH_STATUS:
            return {
                ...state,
                isSearchstarted: action.isSearchstarted
            };
        case CLEAR_INSTRUMENTCONSTANTS_LIST: {
            return {
                ...state,
                instrumentConstantsData: undefined,
                modelname: undefined,
                IsPartConstant: false
            };
            }
        case CLEAR_INSTRUMENTCONSTANTS_EXPORT_LIST:
            {
                return {
                    ...state,
                    instrumentConstantsData: undefined,
                    partNumber: '',
                    fileName: '',
                    selectedFamily: undefined,
                    selectedProductName: undefined,
                    selectedProductModel: undefined,
                };
            }
    }
    return state;
}